export default "__VITE_ASSET__CIkK7oIN__"